import React from "react";
import {Outlet} from "react-router-dom";
// import SettingNavTab from "./SettingNavTab";
import "./Setting.css"
// import "./SettingTabs.css"

function Settings() {

    return (
        <section className="section-bg-color"
                 style={{minHeight: "calc(100vh - 139px)", overflowX: "hidden", }}>
            <div className="p-4">
                {/* <div className="row p-0"> */}
                    {/* <SettingNavTab /> */}

                    {/* <div className="col-12 p-0"> */}
                        <div className="tab-content" id="nav-tabContent"
                             style={{minHeight: "calc(100vh - 0px)", }}>

                            <Outlet/>

                        </div>
                    {/* </div> */}
                {/* </div> */}
            </div>
        </section>
    );
}

export default Settings;